// teamPulse.js — anonymer Team-Puls (eNPS) auf Basis des stats-Stores.
//
// Jede Stimme (0–10 + optionaler Kommentar) landet gesammelt im Datensatz
// (typ "team_pulse", periode "JJJJ-MM") — ohne Absender, bewusst anonym.
// eNPS = %Promotoren (9–10) − %Detraktoren (0–6). Ausgewertet wird ein
// Monat erst ab 3 Stimmen, damit einzelne Antworten nicht zuordenbar sind.
import { listStats, upsertStats } from "./statsStore";

export const pulsePeriode = () => new Date().toISOString().slice(0, 7); // "2026-07"
export const pulseVotedKey = () => `dida_pulse_voted_${pulsePeriode()}`;
export const hasVoted = () => { try { return !!localStorage.getItem(pulseVotedKey()); } catch { return false; } };

export async function submitPulse(score, comment) {
  const rows = await listStats("team_pulse");
  const cur = rows.find(r => r.periode === pulsePeriode());
  const payload = { scores: [...(cur?.payload?.scores || []), score],
    comments: comment ? [...(cur?.payload?.comments || []), comment] : (cur?.payload?.comments || []) };
  await upsertStats([{ typ: "team_pulse", periode: pulsePeriode(), quelle: "team", payload }]);
  try { localStorage.setItem(pulseVotedKey(), "1"); } catch {}
}

export const loadPulse = () => listStats("team_pulse");

export const eNPS = (scores) => {
  if (!scores || !scores.length) return null;
  const p = scores.filter(s => s >= 9).length, d = scores.filter(s => s <= 6).length;
  return Math.round((p - d) / scores.length * 100);
};

export const MIN_VOTES = 3; // Anonymitätsschwelle
